import React, { Component } from "react";
import PropTypes from "prop-types";
import cloneDeep from "lodash/cloneDeep";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import InlineError from "core/components/common/message/InlineError";
import Tabs, { ErrorSection, Tab } from "core/components/common/tabs/Tabs";
import Loading from "components/common/loading/Loading";
import BasicFields, { getBasicInitialValues, getBasicYupSchema } from "./basic/BasicFields";

const topLevelVariables = [
	"name"
];

const PhaseEditMessages = ({ error }) => {
	if (error) {
		return (
			<InlineError>
				<p>There was an error processing your request, please try again.</p>
			</InlineError>
		);
	}

	return "";
};

const PhaseEditFormSchema = Yup.object().shape({
	...getBasicYupSchema()
});

const applyModelToForm = (model) => {
	const form = {};

	const cloneModel = cloneDeep(model);

	// Copy top level
	topLevelVariables.forEach(v => {
		const val = cloneModel[v];
		if (val !== undefined && val !== null) {
			form[v] = val;
		}
	});

	return form;
};

const applyFormToModel = (conditionBuilderType, form, model) => {
	const cloneForm = cloneDeep(form);
	const newModel = cloneDeep(model);

	// Copy top level
	topLevelVariables.forEach(v => {
		if (cloneForm[v] !== undefined && cloneForm[v] !== null) {
			newModel[v] = cloneForm[v];
		}

		delete (cloneForm[v]);
	});

	return newModel;
};

export class PhaseEditForm extends Component {
	state = {
		conditionBuilderType: undefined
	};

	setConditionBuilderType = (conditionBuilderType) => {
		this.setState(() => ({
			conditionBuilderType: conditionBuilderType
		}));

		return false;
	};

	render () {
		let { editState, onSubmit, buttonBgColor, buttonFontColor, buttonLabel } = this.props;
		let { model } = editState;
		if (!model) {
			model = {};
		}
		if (!buttonLabel) {
			buttonLabel = "Save";
		}

		const loading = editState.loading;
		const error = editState.error;

		const { conditionBuilderType } = this.state;

		const formData = applyModelToForm(model);

		const onSubmitAdaptor = (form) => {
			return onSubmit(applyFormToModel(conditionBuilderType, form, model));
		};

		return (
			<Formik
				onSubmit={onSubmitAdaptor}
				initialValues={{
					...getBasicInitialValues(formData)
				}}
				validationSchema={PhaseEditFormSchema}
			>
				{({ errors, touched, ...props }) => (
					<Form className="up-form with-tabs">
						<section className="modal-card-body">
							{loading
								? <Loading/>
								: (
									<>
										<Tabs errors={errors} touched={touched} borderColor={buttonBgColor} {...props}>
											<ErrorSection>
												<PhaseEditMessages error={error}/>
											</ErrorSection>
											<Tab id="basic" title="Basic" fields={["name", "group_id"]}>
												<BasicFields errors={errors} touched={touched} {...props} />
											</Tab>
										</Tabs>
									</>
								)}
						</section>
						<footer className="modal-card-foot">
							<button
								type="submit" className="button is-primary" disabled={loading} style={{
								backgroundColor: buttonBgColor,
								color: buttonFontColor
							}}
							>{buttonLabel}
							</button>
						</footer>
					</Form>
				)}
			</Formik>
		);
	}
}

PhaseEditForm.propTypes = {
	editState: PropTypes.object.isRequired,
	onSubmit: PropTypes.func.isRequired,
	buttonBgColor: PropTypes.string.isRequired,
	buttonFontColor: PropTypes.string.isRequired
};

export default PhaseEditForm;
